import type { TOC } from '@ember/component/template-only';

import GenieFullScreenComponent from 'webapp/components/genie/full-screen/index';
import type MobileGenieChatController from 'webapp/controllers/mobile/genie/chat';

interface Args {
	controller: MobileGenieChatController;
}

const MobileGenieChatRouteTemplate: TOC<Args> = <template>
	<GenieFullScreenComponent
		@contextItems={{@controller.contextItems}}
		@initialMessages={{@controller.initialMessages}}
		@initialPrompt={{@controller.initialPrompt}}
		@selectedAccountIds={{@controller.selectedAccountIds}}
		@chatMode={{@controller.chatMode}}
		@threadId={{@controller.threadId}}
	/>
</template>;

export default MobileGenieChatRouteTemplate;
